function App() {
  return (
    <main className="site-shell">
      <article className="statement" aria-labelledby="page-title">
        <h1 id="page-title">Worlds as the next software primitive.</h1>

        <div className="copy">
          <p>
            Software has spent fifty years being flat. Pages, documents,
            dashboards, feeds. Brilliant, useful, flat.
          </p>
          <p>
            The next layer is worlds: places that run, places you can be inside
            with other people, and places where AI agents can act alongside you.
          </p>
          <p>
            Worlds are also where machine intelligence gets made and measured.
            An agent cannot learn to act from flat data; it needs places with
            physics, other actors, and consequences, where every claim of
            progress can be replayed and verified.
          </p>
          <p>
            We build the systems that generate and run these worlds from words,
            and open them to other people and AI agents in real time at
            {
              " "
            }<a
              href="https://gessa.ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gessa.
            </a>
          </p>
          <p>
            Games come first, deliberately. They are visual, social, real-time,
            and technically unforgiving. A system that can generate and run
            playable multiplayer worlds can carry far more than games.
          </p>
        </div>
      </article>

      <div className="center-brand">
        <img className="brand-mark" src="/favicon.svg" alt="Spatial Instinct" />
      </div>
    </main>
  );
}

export default App;
